import {Component} from 'react';
import React from 'react';
import ValidatedFormComponent from "../ValidatedFormComponent";
import CardSub from "../subcomponents/CardSub";
import Col from "react-bootstrap/es/Col";
import Button from "react-bootstrap/lib/Button";
import Form from "react-bootstrap/lib/Form";
import Row from "react-bootstrap/es/Row";
import request from "request-promise-native";
import Alert from "react-bootstrap/es/Alert";
import OverlayTrigger from "react-bootstrap/es/OverlayTrigger";
import Tooltip from "react-bootstrap/es/Tooltip";
import Badge from "react-bootstrap/es/Badge";
import Pkcs12Utils from "../../utils/Pkcs12Utils";

const SAVE_ENDPOINT = "https://qibipay.azurewebsites.net/api/ConfigureAccount";
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class SettingsTab extends Component {
    constructor(props) {
        /*
            - globalConfig
        */
        super(props);
        this.state = {
            loading: false,
            errorMessage: null,
            customLogo: this.props.globalConfig == null ? false : this.props.globalConfig.enableCustomLogo==null ? false : !!this.props.globalConfig.enableCustomLogo ? true : false,
            balanceReporting: this.props.globalConfig == null ? false : this.props.globalConfig.enableBalanceReporting==null ? false : !!this.props.globalConfig.enableBalanceReporting ? true : false
        }
    }

    async submit() {
        this.setState({
            errorMessage: null,
            warnMessage: null
        });
        if(this.autoregisterRef.validated() && this.merchantUuidRef.validated() && this.limitRef.validated() && this.currencyRef.validated() && this.revalueRef.validated() && this.readLengthRef.validated()) {

            if(!this.flexaAutoUpdateRef.validated()) {
                return;
            }

            if(this.state.customLogo && !this.logoFileRef.validated()) {
                return;
            }

            if(this.state.balanceReporting && (!this.mailRef.validated() || !this.periodRef.validated())) {
                return;
            }

            this.setState({
                loading: true
            });

            const globalConf = {
                autoregister: this.autoregisterRef.value==="true",
                limit: parseFloat(this.limitRef.value),
                currency: this.currencyRef.value,
                revalue: this.revalueRef.value==="true",
                readLength: parseInt(this.readLengthRef.value),

                enableCustomLogo: this.state.customLogo,
                enableBalanceReporting: this.state.balanceReporting,
                merchantUuid: this.merchantUuidRef.value,
                pat: this.patRef.value==="true",
                flexaAutoUpdateInhibit: this.flexaAutoUpdateRef.value==="false"
            };

            if(this.certPassRef.value!="") {
                globalConf.certPass = this.certPassRef.value;
            }

            if(this.certFileRef.files!=null && this.certFileRef.files.length>0) {
                const certFile = this.certFileRef.files[0];
                if (certFile != null) {
                    const reader = new FileReader();

                    const result = await new Promise(function (resolve, reject) {
                        reader.onload = function () {
                            if (reader.result == null) {
                                reject();
                                return;
                            }
                            resolve(reader.result);
                        };
                        reader.readAsDataURL(certFile);
                    }).catch(err => {
                    });

                    let base64enc = result.replace(/^data:(.*;base64,)?/, '');
                    if ((base64enc.length % 4) > 0) {
                        base64enc += '='.repeat(4 - (base64enc.length % 4));
                    }

                    console.log("Base64 encoded: ", base64enc);

                    const daysTillExpiry = Pkcs12Utils.isValid(base64enc, globalConf.certPass);

                    if(daysTillExpiry==null) {
                        this.setState({errorMessage: "Certificate file cannot be parsed, wrong password?", loading: false});
                        return;
                    } else if(daysTillExpiry<0) {
                        this.setState({errorMessage: "Certificate file is already expired ("+(-daysTillExpiry)+" days after expiration)", loading: false});
                        return;
                    } else if(daysTillExpiry<90) {
                        await this.setState({warnMessage: "Warning: Certificate expires in "+daysTillExpiry+" days!"});
                    }

                    globalConf.certificate = base64enc;
                    globalConf.certificateFN = certFile.name;
                    globalConf.certificateExpiry = Pkcs12Utils.getExpiryDate(base64enc, globalConf.certPass);
                    if(globalConf.certificateExpiry!=null) {
                        globalConf.certificateExpiry = globalConf.certificateExpiry.getTime();
                    }
                }
            }

            if(this.state.customLogo) {
                //Put the logo here in Base64
                const file = this.logoFileRef.files[0];
                if(file!=null) {
                    const reader = new FileReader();

                    const result = await new Promise(function (resolve, reject) {
                        reader.onload = function () {
                            if(reader.result==null) {
                                reject();
                                return;
                            }
                            resolve(reader.result);
                        };
                        reader.readAsDataURL(file);
                    }).catch(err => {});

                    let base64enc = result.replace(/^data:(.*;base64,)?/, '');
                    if ((base64enc.length % 4) > 0) {
                        base64enc += '='.repeat(4 - (base64enc.length % 4));
                    }

                    console.log("Base64 encoded: ",base64enc);

                    globalConf.customLogo = base64enc;
                    globalConf.customLogoType = file.type;
                }
            }

            if(this.state.balanceReporting) {
                globalConf.reportingMail = this.mailRef.value;
                globalConf.reportingPeriod = this.periodRef.value;
            }

            const body = { ... globalConf };
            body.access_code = this.props.access_code;

            const options = {
                method: 'POST',
                uri: SAVE_ENDPOINT,
                body: body,
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            if(response.statusCode===404) {
                this.props.logout();
                return;
            }

            if(response.statusCode!=200) {
                this.setState({errorMessage: "Error saving config: "+response.body, loading: false});
                return;
            }

            this.setState({
                loading: false
            });

            delete globalConf.customLogo;
            this.props.setGlobalConfig(globalConf);

        }
    }

    render() {
        return (

            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><i className="mdi mdi-settings"></i> Settings</h3>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">

                    {this.state.errorMessage==null ? '' : (
                        <Alert bsStyle="danger"><strong>{this.state.errorMessage}</strong></Alert>
                    )}
                    {this.state.warnMessage==null ? '' : (
                        <Alert bsStyle="warning"><strong>{this.state.warnMessage}</strong></Alert>
                    )}

                    <Col xl={6} lg={8} md={9} sm={9} xs={12}>

                        <ValidatedFormComponent
                            type={"boolean"}
                            onValidate={() => null}
                            defaultValue={this.props.globalConfig == null ? "false" : this.props.globalConfig.autoregister==null ? "false" : !!this.props.globalConfig.autoregister ? "true" : "false"}
                            name="Enable card auto-registration"
                            displayname={(<div>
                                Enable card auto-registration <OverlayTrigger
                                    key="tooltipAutoregister"
                                    placement="right"
                                    overlay={
                                        <Tooltip id={`tooltip-autoregister`}>
                                            Indicates if devices should automatically add non-existent cards to the system as soon as they are scanned
                                        </Tooltip>
                                    }
                                >
                                    <Badge>?</Badge>
                                </OverlayTrigger>
                            </div>)}
                            inputRef={(ref) => {
                                this.autoregisterRef = ref;
                            }}/>

                        <ValidatedFormComponent
                            type={"number"}
                            onValidate={() => null}
                            defaultValue={this.props.globalConfig == null ? 0 : this.props.globalConfig.limit==null ? 0 : this.props.globalConfig.limit}
                            name="Card credit limit"
                            displayname={(<div>
                                Card credit limit <OverlayTrigger
                                key="tooltipLimit"
                                placement="right"
                                overlay={
                                    <Tooltip id={`tooltip-limit`}>
                                        Maximum amount of credit that the card can have. Set to 0 if you want to disable this limit!
                                    </Tooltip>
                                }
                            >
                                <Badge>?</Badge>
                            </OverlayTrigger>
                            </div>)}
                            min={0}
                            step={0.01}
                            decimal={true}
                            inputRef={(ref) => {
                                this.limitRef = ref;
                            }}/>

                        <ValidatedFormComponent
                            type={"number"}
                            onValidate={() => null}
                            defaultValue={this.props.globalConfig == null ? 0 : this.props.globalConfig.readLength==null ? 0 : this.props.globalConfig.readLength}
                            name="Scan card ID length"
                            displayname={(<div>
                                Scan card ID length <OverlayTrigger
                                key="tooltipLength"
                                placement="right"
                                overlay={
                                    <Tooltip id={`tooltip-length`}>
                                        Makes <strong>android</strong> devices only accept card IDs of the desired length. Useful when your reader is interpreting some random noise as a QR/Barcode. Set to 0 to disable!
                                    </Tooltip>
                                }
                            >
                                <Badge>?</Badge>
                            </OverlayTrigger>
                            </div>)}
                            min={0}
                            step={1}
                            decimal={false}
                            inputRef={(ref) => {
                                this.readLengthRef = ref;
                            }}
                        />

                        <ValidatedFormComponent
                            type={"select"}
                            onValidate={() => null}
                            name="Currency"
                            inputRef={(ref) => {
                                this.currencyRef = ref;
                            }}
                            value_key={"value"}
                            defaultValue={this.props.globalConfig == null ? "CHF" : this.props.globalConfig.currency==null ? "CHF" : this.props.globalConfig.currency}
                            display_name_key={"name"}
                            options={[
                                {
                                    name: "CHF",
                                    value: "CHF"
                                },
                                {
                                    name: "EUR",
                                    value: "EUR"
                                },
                                {
                                    name: "USD",
                                    value: "USD"
                                }
                            ]}/>

                        <ValidatedFormComponent
                            type={"boolean"}
                            inputRef={(ref) => {
                                this.revalueRef = ref;
                            }}
                            onValidate={() => null}
                            defaultValue={this.props.globalConfig == null ? "false" : this.props.globalConfig.revalue==null ? "false" : !!this.props.globalConfig.revalue ? "true" : "false"}
                            name="Enable revalue"/>

                        <ValidatedFormComponent
                            type={"boolean"}
                            inputRef={(ref) => {
                                this.customLogoRef = ref;
                            }}
                            onChange={(value) => {
                                this.setState({
                                    customLogo: value==="true"
                                });
                            }}
                            onValidate={() => null}
                            value={this.state.customLogo ? "true" : "false"}
                            name="Custom logo"/>

                        {this.state.customLogo ? (
                            <ValidatedFormComponent
                                type={"file"}
                                inputRef={(ref) => {
                                    this.logoFileRef = ref;
                                    this.logoFileRef.accept = "image/png, image/jpeg";
                                    this.logoFileRef.multiple = false;
                                }}
                                onValidate={(value) => {
                                    if(this.logoFileRef.files==null || this.logoFileRef.files.length>1) {
                                        return "You can only select one file!";
                                    }

                                    if(this.logoFileRef.files.length===0) return null;

                                    const file = this.logoFileRef.files[0];
                                    console.log("File: ",file);

                                    if(file.type!=="image/png" && file.type!=="image/jpeg") {
                                        return "You can only upload .png or .jpg files as a custom logo!";
                                    }

                                    //MAX size 2MiB
                                    if(file.size>2*1024*1024) {
                                        return "File cannot be larger than 2MiB!";
                                    }

                                    return null;
                                }}
                                name="Custom logo file"/>
                        ) : ""}

                        <ValidatedFormComponent
                            type={"boolean"}
                            inputRef={(ref) => {
                                this.balanceReportingRef = ref;
                            }}
                            onChange={(value) => {
                                this.setState({
                                    balanceReporting: value==="true"
                                });
                            }}
                            onValidate={() => null}
                            value={this.state.balanceReporting ? "true" : "false"}
                            name="Balance reporting"/>

                        {this.state.balanceReporting ? (
                            <div>
                                <ValidatedFormComponent type="text"
                                                        placeholder="Enter your e-mail address"
                                                        onValidate={input => {
                                                            if(!EMAIL_REGEX.test(input)) return "Not a valid e-mail!";
                                                            return null;
                                                        }}
                                                        defaultValue={this.props.globalConfig == null ? "" : this.props.globalConfig.reportingMail==null ? "" : this.props.globalConfig.reportingMail}
                                                        inputRef={ref => this.mailRef=ref}
                                                        name={"Reporting e-mail"}
                                />

                                <ValidatedFormComponent type="select"
                                                        onValidate={input => {
                                                            return null;
                                                        }}
                                                        inputRef={ref => this.periodRef=ref}
                                                        name={"Reporting period"}
                                                        options={[
                                                            {
                                                                name: "Weekly",
                                                                value: "week"
                                                            },
                                                            {
                                                                name: "Monthly",
                                                                value: "month"
                                                            }
                                                        ]}
                                                        defaultValue={this.props.globalConfig == null ? "week" : this.props.globalConfig.reportingPeriod==null ? "week" : this.props.globalConfig.reportingPeriod}
                                                        value_key={"key"}
                                                        display_name_key={"name"}
                                />
                            </div>
                        ) : ""}

                        <ValidatedFormComponent type="text"
                                                placeholder="Enter merchant uuid"
                                                onValidate={input => {
                                                    return null;
                                                }}
                                                defaultValue={this.props.globalConfig == null ? "" : this.props.globalConfig.merchantUuid==null ? "" : this.props.globalConfig.merchantUuid}
                                                inputRef={ref => this.merchantUuidRef=ref}
                                                name={"Twint merchant UUID"}
                                                />

                        <ValidatedFormComponent
                            type={"file"}
                            inputRef={(ref) => {
                                this.certFileRef = ref;
                                this.certFileRef.multiple = false;
                            }}
                            onValidate={(value) => {
                                if(this.certFileRef.files==null || this.certFileRef.files.length>1) {
                                    return "You can only select one file!";
                                }

                                if(this.certFileRef.files.length===0) return null;

                                const file = this.certFileRef.files[0];
                                console.log("File: ",file);

                                //MAX size 10KiB
                                if(file.size>10*1024) {
                                    return "File cannot be larger than 10KiB!";
                                }

                                return null;
                            }}
                            name="Twint certificate"
                            currFN={this.props.globalConfig.certificateFN}
                        />

                        {this.props.globalConfig.certificateExpiry ? (
                            <Alert bsStyle="info">
                                Certificate expiry date: {new Date(this.props.globalConfig.certificateExpiry).toLocaleString()}
                            </Alert>
                        ) : ""}


                        <ValidatedFormComponent type="password"
                                                placeholder="Enter certificate password"
                                                onValidate={input => {
                                                    return null;
                                                }}
                                                defaultValue={this.props.globalConfig == null ? "" : this.props.globalConfig.certPass==null ? "" : this.props.globalConfig.certPass}
                                                inputRef={ref => this.certPassRef=ref}
                                                name={"Twint certificate password"}
                        />

                        <ValidatedFormComponent type="boolean"
                                                onValidate={input => {
                                                    return null;
                                                }}
                                                defaultValue={this.props.globalConfig == null ? "false" : this.props.globalConfig.pat==null ? "false" : this.props.globalConfig.pat ? "true" : "false"}
                                                inputRef={ref => this.patRef=ref}
                                                name={"Twint PAT"}
                        />

                        <ValidatedFormComponent name="Flexa base scripts auto-updater"
                                                type="boolean"
                                                placeholder=""
                                                onValidate={input => {
                                                    return null;
                                                }}
                                                defaultValue={this.props.globalConfig == null ? "true" : this.props.globalConfig.flexaAutoUpdateInhibit==null ? "true" : !!this.props.globalConfig.flexaAutoUpdateInhibit ? "false" : "true"}
                                                inputRef={ref => this.flexaAutoUpdateRef=ref}
                        />

                        <Row>
                            <Button bsStyle="primary" onClick={this.submit.bind(this)} disabled={this.state.loading}>
                                <i className="fa fa-save"/> {this.state.loading ? "Saving..." : "Save"}
                            </Button>
                        </Row>

                    </Col>

                </div>


            </div>
        );
    }
}

export default SettingsTab;